import { render, staticRenderFns } from "./WrapperSvgTitleText.vue?vue&type=template&id=fb5e0c2e"
import script from "./WrapperSvgTitleText.vue?vue&type=script&lang=js"
export * from "./WrapperSvgTitleText.vue?vue&type=script&lang=js"
import style0 from "./WrapperSvgTitleText.vue?vue&type=style&index=0&id=fb5e0c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports